import type { DiffDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { Table } from '@flos/react-ui';
import { toLongDateString } from '../../../../../utils/dateUtil';
import Currency from '../../../../../shared_components/Currency/Currency';

const CoverableChange = ({ change }: { change: DiffDTO }): React.JSX.Element => {
    const valueType = change.after?.valueType;

    const assignValue = (diffDTO: DiffDTO, isPreviousValue: boolean): React.JSX.Element => {
        const change = isPreviousValue ? diffDTO.before : diffDTO.after;
        let value = <>-</>;
        if (!change) return value;

        switch (valueType) {
            case 'LocalDateDTO':
                if (change.dateValue !== undefined)
                    value = <>{toLongDateString(change.dateValue)}</>;
                break;
            case 'Boolean':
                if (change.booleanValue !== undefined)
                    value = <>{change.booleanValue ? 'Ja' : 'Nej'}</>;
                break;
            case 'String': {
                if (change.stringValue?.includes(',00') && change.stringValue !== '0,00 kr.') {
                    value = <>{change.stringValue.split(',00').join('')}</>;
                    break;
                }
                if (change.stringValue === '0 kr.') {
                    value = <>{'0,00 kr.'}</>;
                    break;
                }
                const defaultValue =
                    diffDTO.before?.stringValue?.includes(' kr.') ||
                    diffDTO.after?.stringValue?.includes(' kr.')
                        ? '0,00 kr.'
                        : '-';
                value = <>{change.stringValue ?? defaultValue}</>;
                break;
            }
            case 'AmountDTO': {
                if (change.amountValue !== undefined) {
                    const amount = change.amountValue.amount ?? 0;
                    value = (
                        <Currency price={amount} decimals={amount === 0 ? 2 : 0} displayZeroValue />
                    );
                }
                break;
            }
        }
        return value;
    };

    return (
        <>
            <Table.Row>
                <Table.Cell>
                    {`${change.attribute}: `}
                    {assignValue(change, true)}
                </Table.Cell>
                <Table.Cell align="right">
                    {`${change.attribute}: `}
                    {assignValue(change, false)}
                </Table.Cell>
            </Table.Row>
        </>
    );
};

export default CoverableChange;
